import { snapshot } from 'valtio'
import { emailRegex, postalCodeRegex } from '../../utils/formattingUtils'
import { customerAddProxy } from './customerAddProxy'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const FIELDS_REQUIRED_FOR_SUBMISSION = [
  FormFieldNamesEnum.City,
  FormFieldNamesEnum.PostalCode,
  FormFieldNamesEnum.State,
  FormFieldNamesEnum.StreetAddressOne,
  FormFieldNamesEnum.CountryCode
]

export const NAME_FIELDS_REQUIRED_FOR_SUBMISSION = [
  FormFieldNamesEnum.FirstName,
  FormFieldNamesEnum.LastName
]

export const COMPANY_FIELD_REQUIRED_FOR_SUBMISSION = [
  FormFieldNamesEnum.CompanyName
]

export const validators: { [key in FormFieldNamesEnum]?: (arg0: string) => string | null } = {

  [FormFieldNamesEnum.CompanyName]: val => {
    if (!val) {
      const { formValues } = snapshot(customerAddProxy)
      if (!(formValues[FormFieldNamesEnum.FirstName] && formValues[FormFieldNamesEnum.LastName])) {
        return 'Company name is Required'
      }
    } else {
      //If we have a company name, delete the errors for first and last name...BC
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete customerAddProxy.formErrors[FormFieldNamesEnum.FirstName]
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete customerAddProxy.formErrors[FormFieldNamesEnum.LastName]
    }
    return null
  },
  [FormFieldNamesEnum.Email]: val => {
    if (!val) { return 'Email is Required' }
    if (!emailRegex.test(val)) { return 'Invalid email format' }
    return null
  },
  [FormFieldNamesEnum.FirstName]: val => {
    if (!val) {
      const { formValues } = snapshot(customerAddProxy)
      if (!formValues[FormFieldNamesEnum.CompanyName]) {
        return 'First Name is Required'
      }
    } else {
      //If we have a First Name, delete the errors for company name...BC
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete customerAddProxy.formErrors[FormFieldNamesEnum.CompanyName]
    }
    return null
  },
  [FormFieldNamesEnum.LastName]: val => {
    if (!val) {
      const { formValues } = snapshot(customerAddProxy)
      if (!formValues[FormFieldNamesEnum.CompanyName]) {
        return 'Last Name is Required'
      }
    } else {
      //If we have a Last Name, delete the errors for company name...BC
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete customerAddProxy.formErrors[FormFieldNamesEnum.CompanyName]
    }
    return null
  },
  [FormFieldNamesEnum.StreetAddressOne]: val => {
    if (!val) { return 'Address is Required' }
    return null
  },
  [FormFieldNamesEnum.City]: val => {
    if (!val) { return 'City is Required' }
    return null
  },
  [FormFieldNamesEnum.State]: val => {
    if (!val) { return 'State is Required' }
    return null
  },
  [FormFieldNamesEnum.PostalCode]: val => {
    if (!val) { return 'Postal Code is Required' }
    if (val.length !== 5) { return 'Must be 5 digits' }
    if (!postalCodeRegex.test(val)) { return 'Invalid postal code format' }
    return null
  }
}
